import { render } from "./StrukturLevel.vue?vue&type=template&id=4485615b&scoped=true"
import script from "./StrukturLevel.vue?vue&type=script&lang=js"
export * from "./StrukturLevel.vue?vue&type=script&lang=js"

import "./StrukturLevel.vue?vue&type=style&index=0&id=4485615b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4485615b"]])

export default __exports__